
import { BrowserRouter } from 'react-router-dom';
import ServiceTemplate from './pages/Index';
console.log = () => {}
console.error = () => {} 
function App() {
  return (
    <BrowserRouter>
     <div className="App">
     <ServiceTemplate/>
    </div>
    </BrowserRouter>
   
  );
}

export default App;
